import "@mantine/core/styles.css";
import "@mantine/notifications/styles.css";
import "./styles/globals.scss";

import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";
import { Notifications } from "@mantine/notifications";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./app/routes";
import { globalTheme } from "./app/globalTheme";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <MantineProvider theme={globalTheme}>
        <ModalsProvider>
          <Notifications />
          <AppRoutes />
        </ModalsProvider>
      </MantineProvider>
    </BrowserRouter>
  </StrictMode>
);
